














































































  import { Component, Prop } from 'nuxt-property-decorator'
  import OneWishlistProductRowLine from '~/components/organisms/orderpath/OneWishlistProductRowLine.vue'

  @Component
  export default class OneWishlistProductRowMobileTile extends OneWishlistProductRowLine {
    name: string = 'one-wishlist-product-row-mobile-tile'

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    readonly hasChildren!: boolean

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    readonly isLastTile!: boolean

    get tileClasses(): Record<string, boolean> {
      return {
        'one-wishlist-product-row-mobile-tile--last-tile': this.isLastTile,
      }
    }
  }
